import React from 'react';
import styled from 'styled-components';

import { greenColor, lightGrey2Color } from 'js/config/style';
import Icon from 'js/components/common/Icon';

const CheckMark = styled(Icon).attrs({ name: 'check' })`
  color: ${greenColor};
  margin-right: 0.25rem;
`;

const WaitingMark = styled(Icon).attrs({ name: 'clock-o' })`
  color: ${lightGrey2Color};
  margin-right: 0.25rem;
`;

const Container = styled.div`
  grid-area: verified;
  font-size: 0.8rem;
  font-weight: 500;
  align-self: center;
  justify-self: center;
`;

export default ({ verified }) => (
  <Container>
    {verified ? <CheckMark title="Account is verified" /> : <WaitingMark title="Account not yet verified" />}
  </Container>
);
